import barba from '@barba/core';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.scrollTrigger(data.next.container)
        });
        barba.hooks.after((data) => {
            this.scrollTrigger(data.next.container)
        });
    }
    scrollTrigger(container){

        this.bnrHidden = gsap.utils.toArray(".l-header__fixed--bnr");

        if(this.bnrHidden) {
            gsap.set(this.bnrHidden, {
                autoAlpha: 1,
            });
            gsap.to(this.bnrHidden, {
                autoAlpha: 0,
                duration: .4,
                ease: "expo.inOut",
                scrollTrigger: {
                    trigger: "#l-aside__contact",
                    start: "top bottom",
                    end: "bottom bottom",
                    toggleActions: "play none none reverse",
                    // markers: true,
                }
            });
        }
    }
}